export { default } from "./InsertTarget";
